var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepTwo = function SvgStepTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#305992"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.28 24.26c.453-.36.66-.527.62-.5 1.307-1.08 2.333-1.967 3.08-2.66.76-.693 1.4-1.42 1.92-2.18.52-.76.78-1.5.78-2.22 0-.547-.127-.973-.38-1.28-.253-.307-.633-.46-1.14-.46-.507 0-.907.193-1.2.58-.28.373-.42.907-.42 1.6h-3.3c.027-1.133.267-2.08.72-2.84.467-.76 1.073-1.32 1.82-1.68.76-.36 1.6-.54 2.52-.54 1.587 0 2.78.407 3.58 1.22.813.813 1.22 1.873 1.22 3.18 0 1.427-.487 2.753-1.46 3.98-.973 1.213-2.213 2.4-3.72 3.56h5.4v2.78H15.28v-2.54Z",
    fill: "#fff"
  })));
};
export default SvgStepTwo;